<script>
import AppLayoutNoAuth from '@/Layout/AppLayoutNoAuth'
export default {
	layout: AppLayoutNoAuth
}
</script>

<script setup>
import Payment from "@/Pages/Public/MembershipApplication/Payment"

const props = defineProps({
	membershipApplication: {
		required: true,
	}
})
</script>

<template>
	<Payment
		:membershipApplication="membershipApplication"
	/>
</template>